import { MapPin, MessageCircle } from 'lucide-react';
import { citySlug } from '../../lib/citySlug';

export const CityCard = ({ city }) => (
<a
                  data-testid={`city-link-${citySlug(city)}`}
                  href={`#${citySlug(city)}`}
                  className="group bg-gradient-to-br from-gray-900 to-gray-950 border-2 border-red-900/40 hover:border-red-600/70 p-6 rounded-xl transition-all duration-300 transform hover:scale-105 hover:shadow-2xl hover:shadow-red-600/30 cursor-pointer"
                >
                  <div className="flex items-center space-x-4 mb-3">
                    <div className="bg-gradient-to-br from-red-600 to-red-800 p-3 rounded-lg group-hover:scale-110 transition-transform">
                      <MapPin className="w-6 h-6 text-white" />
                    </div>
                    <div className="flex-1">
                      <h3 className="text-xl font-bold text-white group-hover:text-red-400 transition-colors">{city}</h3>
                    </div>
                  </div>
                  <div className="space-y-2 text-sm">
                    <p className="text-gray-400 group-hover:text-gray-300">✓ Marabout Sorcier Vaudou</p>
                    <p className="text-gray-400 group-hover:text-gray-300">✓ Retour Affectif Rapide</p>
                    <p className="text-gray-400 group-hover:text-gray-300">✓ Rituel Magie Blanche/Rouge</p>
                    <p className="text-gray-400 group-hover:text-gray-300">✓ Désenvoutement Efficace</p>
                    <p className="text-gray-400 group-hover:text-gray-300">✓ Voyant Médium Sérieux</p>
                  </div>
                  <div className="mt-4 pt-4 border-t border-red-900/30">
                    <p className="text-green-500 font-semibold text-sm flex items-center">
                      <MessageCircle className="w-4 h-4 mr-2" />
                      WhatsApp Disponible
                    </p>
                  </div>
                </a>
);
